import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { BackendService } from '@wilson/base';
import { ConfigOptions, ConfigService } from '@wilson/config';
import { UserVacation } from '@wilson/interfaces';
import { firstValueFrom, Observable } from 'rxjs';

@Injectable()
export class VacationManagementService extends BackendService<UserVacation> {
  protected readonly http = inject(HttpClient);
  protected readonly config = inject<ConfigOptions>(ConfigService);

  protected readonly path = 'user-vacations';

  public getUserVacationByIdAndYear(
    userId: string | undefined,
    year: number,
  ): Observable<UserVacation[]> {
    return this.http.post<UserVacation[]>(
      `${this.config.host}/${this.path}/search`,
      {
        userId,
        year,
      },
    );
  }

  public createUserVacations(
    userVacations: UserVacation[],
  ): Promise<UserVacation[]> {
    return firstValueFrom(
      this.http.post<UserVacation[]>(`${this.config.host}/${this.path}/`, {
        items: userVacations,
      }),
    );
  }

  public createUserVacationsV2(
    userVacations: UserVacation,
  ): Promise<UserVacation> {
    return firstValueFrom(
      this.http.post<UserVacation>(`${this.config.host}/${this.path}`, {
        items: userVacations,
      }),
    );
  }

  public updateUserVacationsV2(
    userVacations: UserVacation,
  ): Promise<UserVacation> {
    return firstValueFrom(
      this.http.patch<UserVacation>(
        `${this.config.host}/${this.path}/${userVacations.id}`,
        {
          ...userVacations,
        },
      ),
    );
  }
}
